import type { RightPanelSurface } from "~/rightPanelStore";
import {
  createDelegatedWorkspaceSurface,
  type DelegatedWorkspaceSurfaceContextValue,
} from "~/workspaceSurfaceContext";

type BrowserDescriptor = Extract<RightPanelSurface, { readonly kind: "preview" }>;

export type BrowserWorkspaceSurfaceContextValue =
  DelegatedWorkspaceSurfaceContextValue<BrowserDescriptor>;

/** Browser-owned adapter for the Workspace Surface Host renderer seam. */
const browserWorkspaceSurface = createDelegatedWorkspaceSurface<
  RightPanelSurface,
  BrowserDescriptor
>((descriptor): descriptor is BrowserDescriptor => descriptor.kind === "preview");

export const BrowserWorkspaceSurfaceProvider = browserWorkspaceSurface.Provider;
export const BrowserWorkspaceSurface = browserWorkspaceSurface.Surface;
